"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurretHelper = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var yieldblox_base_1 = require("yieldblox-base");
var TurretHelper = (function () {
    function TurretHelper() {
    }
    TurretHelper.GetTurrets = function (governance) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var turrets, allData, dataKeys, i, turretDataKey, turretDataEntry, t;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        turrets = new Array();
                        allData = governance.data.getAllDataEntries();
                        dataKeys = Object.keys(allData);
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < dataKeys.length)) return [3, 4];
                        turretDataKey = dataKeys[i];
                        if (!turretDataKey.startsWith("turret.")) return [3, 3];
                        turretDataEntry = allData[turretDataKey];
                        return [4, TurretHelper.DecodeTurretFromData(turretDataKey, turretDataEntry)];
                    case 2:
                        t = _a.sent();
                        turrets.push(t);
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3, 1];
                    case 4: return [2, turrets];
                }
            });
        });
    };
    TurretHelper.GetTurret = function (governance, accountId) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var turrets;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, TurretHelper.GetTurrets(governance)];
                    case 1:
                        turrets = _a.sent();
                        return [2, turrets.find(function (x) { return x.accountId == accountId; })];
                }
            });
        });
    };
    TurretHelper.GetContract = function (governance) {
        return governance.data.getContractHash();
    };
    TurretHelper.DecodeTurretFromData = function (turretDataKey, turretDataEntry) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var server, turretSigner, turretAddress, turretAccount, rootUrl, resp, turretInfo, turret;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        server = yieldblox_base_1.HorizonServer.getInstance();
                        turretSigner = turretDataKey.replace("turret.", "");
                        turretAddress = Buffer.from(turretDataEntry, "base64").toString();
                        turretAddress = turretAddress.replace(/[^\x00-\x7F]/g, "");
                        return [4, server.GetAccountAsync(turretAddress)];
                    case 1:
                        turretAccount = _a.sent();
                        rootUrl = "https://" + turretAccount.home_domain;
                        return [4, axios_1.default.get(rootUrl, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })];
                    case 2:
                        resp = _a.sent();
                        turretInfo = resp.data;
                        turret = {
                            turretId: this.getTurretId(turretAddress),
                            accountId: turretAddress,
                            signerId: turretSigner,
                            rootUrl: "https://" + turretAccount.home_domain,
                            info: turretInfo,
                        };
                        return [2, turret];
                }
            });
        });
    };
    TurretHelper.getTurretId = function (accountId) {
        var idStr = accountId;
        return idStr;
    };
    return TurretHelper;
}());
exports.TurretHelper = TurretHelper;
//# sourceMappingURL=TurretHelper.js.map